var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exception" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("h1", [_vm._v("500")]),
      _vm._v(" "),
      _c("div", { staticClass: "desc" }, [_vm._v("对不起，系统开小差了")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action" },
        [
          _c("span", { staticStyle: { color: "red", "font-size": "28px" } }, [
            _vm._v("\n       " + _vm._s(_vm.time) + "s\n      ")
          ]),
          _vm._v("后自动跳转至首页\n      "),
          _c("br"),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v("返回首页")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: {
          src:
            "https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-940de63e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-940de63e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/exception/500.vue
// module id = null
// module chunks = 